export class MMSTATS {
  constructor(slogbase, acc, opt) {
    let mm = this;
    mm.slogbase = slogbase;
    mm.acc = acc;
    mm.colorlist = ["0,0,255",   "0,255,0",   "255,0,0",
                    "0,255,255", "200,200,0", "255,0,255",
                    "0,128,255", "128,255,0", "255,0,128",
                    "0,255,128", "255,128,0", "128,0,255",
                    "0,0,160",   "0,160,0",   "160,0,0",
                    "0,160,160" ,"160,160,0", "160,0,160",
                   ];
    mm.loading_cb = opt.loading_cb;
    mm.update_cb = opt.update_cb;
  }

  attach(el) {
    let mm = this;
    let h = "";

    h += '  <canvas id="myChart1" style="width:100%;height:100%;"></canvas>';
    el.innerHTML = h;
  }

  attachSess(el) {
    let mm = this;
    let h = "";
    h += '  <canvas id="mySess1" style="width:100%;height:100%;"></canvas>';
    el.innerHTML = h;
  }

  loadingStatus(i,max) {
    let mm = this;
    mm.loading_cb && mm.loading_cb(Math.trunc((100*i)/max));
  }

  secToYYYYMMDDHH(ep) {
    let mm = this;
    var curdate = new Date(ep);
    var re = new RegExp('[T\\-\\:]');
    var parts = curdate.toJSON().split(re);
    return parts[0]+parts[1]+parts[2]+parts[3];
  }

  addHour(ep) {
    let mm = this;
    let for_hr = Math.trunc(ep/3600000)*3600;
    mm.all_hours[for_hr] = true;
    return mm.secToYYYYMMDDHH(ep);
  }

  getHoursList(ep) {
    let mm = this;
    if (!mm.all_hours) { return []; }
    let list = Object.keys(mm.all_hours);
    return list.sort(function(a, b) {
      return b - a;
    });
  }

  selectDateRange(range) {
    let mm = this;
    //console.log("selectDateRange",range);

    /* Convert range into hours/days */
    let r = range.split(",");
    let s = +r[0];     // Start Ep      (<empty>, <epoch>)
    let e = r[1];      // End Ep        ("now", <epoch>)
    let sp = +r[2];    // How Many Days (0.5, 1, 7, 32, etc.)
    let maxhours = 24;
    let ep;

    if (e == "now") {
      // Loop starts ep at end => "now"
      ep = new Date().getTime();
      // do not use start
      s = 0;
      // sp is how many days
      if (sp < 1) {
        // For < 1 day, reduce hours
        maxhours = sp*24;
      }
    } else {
      // Loop starts ep at end => <epoch>      
      ep = new Date(+e);
      // Loop will end when it reachs start 's'
      //   so just make sure count-of-days is plenty buig
      sp += 1;
    }
    //console.log("s "+s+" e "+ep+" sp "+sp);

    /* Loop starts at most recent (ep => 'e' end) and 
     *   reduces ep by an hour until it reachs the start */
    mm.all_hours = {};
    var list = [];
    for (var i=0; i<sp && ep>=s; i++) {
      for (var h=0; h<maxhours && ep>=s; h++) {
        list.push(mm.addHour(ep));
        ep -= (3600*1000);
      }
    }
    //console.log(list);
    //console.log(mm.getHoursList());

    mm.db = {};
    mm.allRooms = {};
    mm.dbQueryList(list);
  }

  updateToNow(ev) {
    let mm = this;
    let all_hours = mm.getHoursList();
    //console.log("updateToNow",JSON.stringify(all_hours));
    if (all_hours.length < 2) {
      return;
    }

    let now = Math.trunc(Date.now()/3600)*3600;
    let list = [];
    let ep;

    ep = 1000*all_hours[1];
    while (ep < now) {
      list.push(mm.addHour(ep));
      ep += (3600 * 1000);
    }

    //console.log("UPDATE1",list);
    //console.log("UPDATE2",JSON.stringify(mm.getHoursList()));
    mm.dbQueryList(list);
  }

  updateOlder(hours) {
    let mm = this;
    let all_hours = mm.getHoursList();
    let cnt = hours || 1;
    //console.log("updateToNow",JSON.stringify(all_hours));
    if (all_hours.length < 2) {
      return;
    }

    let list = [];
    let ep;

    ep = 1000*all_hours[all_hours.length-1];
    while (cnt) {
      ep -= (3600 * 1000);
      list.push(mm.addHour(ep));
      cnt --;
    }

    //console.log("UPDATE1",list);
    //console.log("UPDATE2",JSON.stringify(mm.getHoursList()));
    mm.dbQueryList(list);
  }

  acRoomName(str) {
    let mm = this;
    let rsp = [];
    Object.keys(mm.allRooms).forEach(function(nm) {
      if (nm.indexOf(str) >= 0) {
        rsp.push(nm);
      }
    });
    return rsp;
  }
  
  async dbQueryList(list) {
    let mm = this;
    let url = mm.slogbase+"/stat/q/";
    for (let i=0; i<list.length; ++i) {
      let hr = list[i];
      if (mm.acc != "uploadvue" && mm.acc != "vcafe") {
        hr += "/"+mm.acc;
      }
      const response = await fetch(url+hr);
      const data = await response.json();
      if (!data.ok) { continue; }
      if (!data.stats) { continue; }
      //console.log(hr,data);
      mm.loadingStatus(i,list.length);
      data.stats.forEach(function(st) {
        //console.log(data.hr,st.acc,st.id);
        mm.mergeStat(data.hr,st);
      });
    }

    mm.loadingStatus(0,0);
    mm.aggregateStats();
    mm.createGraph();
    mm.update_cb && mm.update_cb();
  }

  mergeStat(hr,st) {
    let m = this;
    Object.keys(st).forEach(function(f) {
      if (f.indexOf("at") != 0) { return; }
      let info = st[f];
      let tm = +f.substring(2);
      /* Unique session id for user + window id, since
         the same session might involve multiple windows */
      let key = st.id+"-"+info.w;
      let sess = m.db[key];
      if (!sess) {
        m.db[key] = sess = {};
        sess.events = {};
      }
      if (info.r) {
        info.r.fn = info.r.a + "/"+ info.r.r;
      }
      sess.events[tm] = info;
      //console.log(key,tm,sess.events[tm]);
    });
  }


  showAll() {
    let mm = this;
    mm.aggregateStats();
    mm.createGraph();
  }

  filterByRoom(room) {
    let mm = this;
    mm.aggregateRoomStats(room);
    mm.createGraph();
  }

  /****************************************************************
   * Combine hourly stats 
   ****************************************************************/

  aggregateStats() {
    let mm = this;
    let accum = ["loads","homes","homes_tm","chats","chats_tm",
                 "rooms", "rooms_tm", "part_tm", "conts",
                 "logins", "login_vx", "login_ext", "login_all",
                 "guests", "guest_fail", "guest_ok",
                 "audios", "videos", "stops"];
    //console.log(JSON.stringify(mm.db));
    mm.all_stats = {};
    Object.keys(mm.db).forEach(function(key) {
      let ss = mm.db[key];

      /* ss is a sequence of events for a given user's window/session 
       */
      let stats = mm.statsFromSession(key,ss);

      /* stats is various impulse and duration events accumulated for
         hour blocks */
      Object.keys(stats).forEach(function(for_hr) {
        let stat = stats[for_hr];
        let blk = mm.all_stats[for_hr];
        if (!blk) {
          blk = mm.all_stats[for_hr] = {};
        }
        /* Accummulate simple stats */
        accum.forEach(function(f) {
          if (!stat[f]) return;
          blk[f] = (blk[f] || 0) + stat[f];
        });
        if (stat.per_room) {
          Object.keys(stat.per_room).forEach(function(room) {
            if (!stat.per_room[room].tm) { return; }
            blk.per_room = blk.per_room || {};
            blk.per_room[room] = mm.initRoomStats(blk.per_room[room]);
            blk.per_room[room].tm += stat.per_room[room].tm;
            blk.per_room[room].cnt += stat.per_room[room].cnt;
          });
        }
      });
    });

    //console.log("AGGR",mm.all_stats);
  }

  aggregateRoomStats(room) {
    let mm = this;
    let accum = ["chats","chats_tm",
                 "rooms", "rooms_tm", "part_tm"];

    //console.log(JSON.stringify(mm.db));
    mm.all_stats = {};
    Object.keys(mm.db).forEach(function(key) {
      let ss = mm.db[key];

      /* ss is a sequence of events for a given user's window/session 
       */
      let stats = mm.statsFromSession(key,ss);

      /* stats is various impulse and duration events accumulated for
         hour blocks */
      Object.keys(stats).forEach(function(for_hr) {
        let stat = stats[for_hr];
        let blk = mm.all_stats[for_hr];
        if (!blk) {
          blk = mm.all_stats[for_hr] = {};
        }

        if (stat.per_room) {
          //console.log("HERE1",room,stat.per_room);
          /* Accummulate simple stats */
          accum.forEach(function(f) {
            //console.log("HERE2",room,stat.per_room,f);
            if (!stat.per_room[room]) return;
            if (!stat.per_room[room][f]) return;
            blk[f] = ((blk[f] || 0) + stat.per_room[room][f]);
            //console.log("HERE3",blk[f]);
          });
        }
      });
    });

    //console.log("AGGR",mm.all_stats);
  }
  
  /****************************************************************
   * Take session event sequence and convert to hourly stats
   ****************************************************************/

  /* Initializes a stat block */
  initStats(stats, for_hr) {
    let x = stats[for_hr];
    if (x) { return x; }

    let init = {
      loads: 0,
      conts: 0,
      homes: 0,
      homes_tm: 0,
      rooms: 0,
      rooms_tm: 0,
      part_tm: 0,
      chats: 0,
      chats_tm: 0,
      uniq_rooms: 0,
      per_room: {},
      logins: 0,
      login_vx: 0,
      login_ext: 0,
      login_all: 0,
      guests: 0,
      guest_fail: 0,
      guest_ok: 0,
      audios: 0,
      videos: 0,
      stops: 0,
    };
    stats[for_hr] = init;
    return init;
  }

  initRoomStats(x,room) {
    let mm = this;
    if (x) { return x; }
    mm.allRooms[room] = true;
    return {
      rooms: 0,
      rooms_tm: 0,
      part_tm: 0,
      chats: 0,
      chats_tm: 0,
    };
  }

  /* This accounts for impulse stats for the hour block.
   * If 'cur' is provided it also starts a range for use
   *    by endSessPart, e.g. entered a room => left a room
   */
  startSessPart(stats, cur, tm, loc, ev) {
    let mm = this;
    let for_hr = Math.trunc(tm / 3600) * 3600;
    if (cur) {
      cur.loc = loc; 
      cur.start_tm = tm;
      cur.for_hr = for_hr;
    }
    let x = mm.initStats(stats, for_hr);

    switch(loc) {
    case "-":
      if (ev.a == "cont") {
        x.conts ++;
      } else if (ev.a == "loading") {
        x.loads ++;
      }
      break;

    case "login":
      switch (ev.a) {
      case "open":
        x.logins ++;
        break;
      case "guest":
        break;
      case "vxsign":
        x.login_vx ++;
        x.login_all ++;
        break;
      case "ggsign":
      case "fbsign":
      case "apsign":
      case "mssign":
        x.login_ext ++;
        x.login_all ++;
        break;
      };
      break;

    case "guest":
      switch (ev.a) {
      case "open":
        x.guests ++;
        break;
      case "fail":
        x.guest_fail ++;
        break;
      case "succ":
        x.guest_ok ++;
        x.login_all ++;
        break;
      };
      break;

    case "home":
      x.homes ++;
      break;
    case "room":
      x.rooms ++;
      if (!x.per_room[ev.r.fn]) {
        x.uniq_rooms ++;
        x.per_room[ev.r.fn] = mm.initRoomStats(null,ev.r.fn);
        cur.fn = ev.r.fn;
      }
      break;
    case "chat":
      x.chats ++;
      if (!x.per_room[ev.r.fn]) {
        x.uniq_rooms ++;
        x.per_room[ev.r.fn] = mm.initRoomStats(null,ev.r.fn);
        cur.fn = ev.r.fn;
      }
      break;
    }
    //console.log(tm,"Start",loc,ev.r);
  }

  /* Accounts for the end of a range event and
   *  divides the total time across the spanned
   *  hour blocks */
  endSessPart(stats, cur, tm, opt) {
    let mm = this;
    if (!cur.loc || !cur.start_tm) { return; }

    while (cur.start_tm < tm) {
      let for_hr = cur.for_hr;
      let nxt_hr = cur.for_hr + 3600;
      if (cur.start_tm >= tm) { break; }

      let delta, delta2=0;
      /* Capturing for room is lated of in-room and capturing start */
      let cap_start = Math.max(cur.start_tm, cur.cap_start_tm);
      let cap_stop;
      if (tm > nxt_hr) {
        /* Time spent in this hour block */
        delta = (nxt_hr - cur.start_tm);
        cur.start_tm = nxt_hr;
        cur.for_hr = nxt_hr;
        cap_stop = nxt_hr;
      } else {
        /* Finished in this hour block */
        delta = (tm - cur.start_tm);
        cur.start_tm = tm;
        cap_stop = tm;
      }
      /* Cap stop, if stopped, is earliest of left-the-room or end-of-hour
         and cap stop time */
      if (cur.cap_stop_tm && cur.cap_stop_tm < cap_stop) {
        cap_stop = cur.cap_stop_tm;
      }
      if (cap_stop > cap_start) {
        delta2 = (cap_stop - cap_start);
      }
      //console.log("HERE3",delta2);

      let x = mm.initStats(stats, for_hr);
      switch(cur.loc) {
      case "home":
        x.homes_tm += delta;
        break;
      case "room":
        x.rooms_tm += delta;
        x.part_tm += delta2;
        if (cur.fn) {
          if (!x.per_room[cur.fn]) {
            x.uniq_rooms ++;
            x.per_room[cur.fn] = mm.initRoomStats(null,cur.fn);
          }
          x.per_room[cur.fn].rooms_tm += delta;
          x.per_room[cur.fn].part_tm += delta2;
          x.per_room[cur.fn].rooms ++;
        }
        break;
      case "chat":
        x.chats_tm += delta;
        if (cur.fn) {
          if (!x.per_room[cur.fn]) {
            x.uniq_rooms ++;
            x.per_room[cur.fn] = mm.initRoomStats(null,cur.fn);
          }
          x.per_room[cur.fn].chats_tm += delta;
          x.per_room[cur.fn].chats ++;
        }
        break;
      }
    }

    /* A 'continue' marker allows accounting of
     *  duration up to the marker and does NOT delete
     *  the 'current'. It does update 'start_tm', moving
     *  it forward to 'now' (i.e. tm). */
    if (!opt || !opt.cont) {
      //console.log(tm,"End",cur.loc);
      delete cur.loc;
      delete cur.start_tm;
    }
  }

  /* Returns an hash of stats[] indexed by UTC hour, e.g.
   *   1656522000 : { ... stats during that hour ... }
   *   1656525600 : { ... stats during that hour ... }
   * Impulse events (loading, room visit, etc.) are accounted
   *   for in the hour that they impulse occurred.
   * Duration events (time spent in room, etc.) are divided
   *   across the hours that they span.
   */
  statsFromSession(key,ss) {
    let mm = this;
    let order = Object.keys(ss.events).sort();
    let stats = {};

    /* Walk events in from oldest to newest */
    let cur = {};
    order.forEach(function(tm_ms) {
      let ev = ss.events[tm_ms];
      let tm = tm_ms/1000;
      switch(ev.p) {
      case "-":
        if (ev.a == "cont") {
          /* Continue whatever is in progress (if anything) */
          mm.endSessPart(stats, cur, tm, {cont: true});
        } else if (ev.a == "close") {
          /* Window closure ends any current */
          mm.endSessPart(stats, cur, tm);
          cur.cap_active = false;
          cur.cap_stop_tm = tm;
        }
        /* Count loads, conts, etc. 
         * Will not affect anything else in progress => 'null' */
        mm.startSessPart(stats, null, tm, "-", ev);
        break;

      case "login":
        mm.startSessPart(stats, null, tm, "login", ev);
        break;

      case "guest":
        mm.startSessPart(stats, null, tm, "guest", ev);
        break;

      case "home":
        if (ev.a == "open") {
          /* OPEN ends any current */
          mm.endSessPart(stats, cur, tm);
          mm.startSessPart(stats, cur, tm, "home", ev);
        } else if (ev.a == "leave") {
          if (cur.loc == "home") {
            /* LEAVE only ends matching type */
            mm.endSessPart(stats, cur, tm);
          }
        }
        break;

      case "room":
        if (ev.a == "open") {
          /* OPEN ends any current */
          mm.endSessPart(stats, cur, tm);
          mm.startSessPart(stats, cur, tm, "room", ev);
        } else if (ev.a == "leave") {
          if (cur.loc == "room") {
            /* LEAVE only ends matching type */
            mm.endSessPart(stats, cur, tm);
          }
        }
        break;

      case "chat":
        if (ev.a == "open") {
          /* OPEN ends any current */
          mm.endSessPart(stats, cur, tm);
          mm.startSessPart(stats, cur, tm, "chat", ev);
        } else if (ev.a == "leave") {
          if (cur.loc == "chat") {
            /* LEAVE only ends matching type */
            mm.endSessPart(stats, cur, tm);
          }
        }
        break;
      
      case "cap":
        if (cur && cur.for_hr) {
          let x = stats[cur.for_hr];
          if (ev.a == "audio") {
            //console.log("AUDIO start");
            if (!cur.cap_active) {
              cur.cap_active = true;
              cur.cap_start_tm = tm;
              cur.cap_stop_tm = 0;
            }
            x.audios ++;
          } else if (ev.a == "video") {
            //console.log("VIDEO start");
            x.videos ++;
          } else if (ev.a == "stop") {
            //console.log("STOP");
            cur.cap_active = false;
            cur.cap_stop_tm = tm;
            x.stops ++;
          }
        }
        break;
      }
    });

    //console.log("SESS",key,stats);
    return stats;
  }

  getSessions() {
    let mm = this;
    let s = [];
    Object.keys(mm.db).forEach(function(key) {
      let sess = mm.db[key];
      let order = Object.keys(sess.events).sort();
      let events = [];
      order.forEach(function(tm_ms) {
        let ev = sess.events[tm_ms];
        let new_ev = {};
        if (ev.a == "cont") {
          let len = events.length;
          if (len > 1 &&
              events[len-1].a == "cont" &&
              events[len-2].a == "cont") {
            /* Keep first and last "continue" of a run */
            events[len-1].tm = tm_ms;
            return;
          }
        }
        new_ev.tm = tm_ms;
        new_ev.p = ev.p;
        new_ev.a = ev.a;
        if (ev.r) { new_ev.r = ev.r; }
        events.push(new_ev);
      });
      s.push({key: key, events: events});
    });
    return s;
  }

  /****************************************************************
   *  Create graph
   ****************************************************************/
  log_suffix(value,x) {
    if (value == 1000000000000) { return value/1000000000000 + "T"+x; }
    if (value == 100000000000) { return value/1000000000 + "G"+x; }
    if (value == 10000000000) { return value/1000000000 + "G"+x; }
    if (value == 1000000000) { return value/1000000000 + "G"+x; }
    if (value == 100000000) { return value/1000000 + "M"+x; }
    if (value == 10000000) { return value/1000000 + "M"+x; }
    if (value == 1000000) { return value/1000000 + "M"+x; }
    if (value == 100000) { return value/1000 + "K"+x; }
    if (value == 10000) { return value/1000 + "K"+x; }
    if (value == 1000) { return value/1000 + "K"+x; }
    if (value == 100) { return  "100"+x; }
    if (value == 10) { return  "10"+x; }
    if (value == 5) { return  "5"+x; }
  }

  getColor(v) {
    let mm = this;
    let str = "rgba("+mm.colorlist[(v % mm.colorlist.length)]+",1)";
    //console.log(str);
    return str;
  }

  createGraph() {
    let mm = this;
    let ctx = document.getElementById("myChart1").getContext('2d');
    if (!mm.myChart1) {
      mm.cfg = {
        type: 'line',
        data: {
          labels: [],
          datasets: [],
        },
        options: {
          title: {
            display: false,
            position: "left",
            text: "",
          },
          animation: {
            duration: 0,
          },
          legend: {
            position:'right'
          },
          tooltips: {
            mode: 'point'
            //mode: 'index'
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              type: "time",
              time: {
                // round: 'day'
                tooltipFormat: 'ddd ll HH:mm',
                //unit: 'day',
                displayFormats: {
                  hour: 'MMM D hA',
                  day: 'YYYY MMM D'
                }
              },
              scaleLabel: {
                display: true,
                labelString: 'Date',
                fontColor:'rgba(250,250,250,1)',
              },
              ticks: {
                fontColor:'rgba(250,250,250,1)',
                color:'rgba(250,250,250,1)',
              },
            }],
            yAxes: [{
              type: "logarithmic",
              display: true,
              position: "left",
              id: "y-axis-count",
              ticks: {
                fontColor:'rgba(250,250,250,1)',
                beginAtZero:true,
                //max:1000,
                //stepSize:5,
                min: 0,
                callback: function(value, index, values) {
                  return mm.log_suffix(value, "");
                },
              },
              gridLines: {
                drawOnChartArea: false,
                color: 'rgba(250,250,250,0.5)',
              },
            },{
              type: "logarithmic",
              display: true,
              position: "right",
              id: "y-axis-dur",
              ticks: {
                fontColor:'rgba(250,250,250,1)',
                beginAtZero:true,
                //max:1000,//axis1_max,
                min:0,
                callback: function(value, index, values) {
                  return mm.log_suffix(value, "s");
                },
              },
              gridLines: {
                drawOnChartArea: true,
                color: 'rgba(250,250,250,0.5)',
              },
            }]
          },
        } // options
      }; // cfg

      /* There is a data set for each graphed value */
      mm.map = {};
      mm.map["homes"] = {
        label:"Home (visits)",
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: mm.getColor(0),
        borderDash: [2,3],
        borderWidth: 2,
        yAxisID: "y-axis-count",
        data:[]
      };
      mm.cfg.data.datasets.push(mm.map["homes"]);
      mm.map["rooms"] = {
        label:"Rooms (visits)",
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: mm.getColor(1),
        borderDash: [2,3],
        borderWidth: 2,
        yAxisID: "y-axis-count",
        data:[]
      };
      mm.cfg.data.datasets.push(mm.map["rooms"]);
      mm.map["loads"] = {
        label:"Loads",
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: mm.getColor(2),
        borderDash: [2,3],
        borderWidth: 2,
        yAxisID: "y-axis-count",
        data:[]
      };
      mm.cfg.data.datasets.push(mm.map["loads"]);
      /*
      mm.map["conts"] = {
        label:"Continues",
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: mm.getColor(3),
        borderDash: [2,3],
        borderWidth: 2,
        yAxisID: "y-axis-count",
        data:[]
      };
      mm.cfg.data.datasets.push(mm.map["conts"]);
      */
      mm.map["logins"] = {
        label:"Login (visits)",
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: mm.getColor(4),
        borderDash: [2,3],
        borderWidth: 2,
        yAxisID: "y-axis-count",
        data:[]
      };
      mm.cfg.data.datasets.push(mm.map["logins"]);
      mm.map["login_all"] = {
        label:"Login (signins)",
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: mm.getColor(5),
        borderDash: [2,3],
        borderWidth: 2,
        yAxisID: "y-axis-count",
        data:[]
      };
      mm.cfg.data.datasets.push(mm.map["login_all"]);
      mm.map["guests"] = {
        label:"Guest (visits)",
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: mm.getColor(6),
        borderDash: [2,3],
        borderWidth: 2,
        yAxisID: "y-axis-count",
        data:[]
      };
      mm.cfg.data.datasets.push(mm.map["guests"]);
      mm.map["guest_fail"] = {
        label:"Guest (fails)",
        backgroundColor: 'rgba(255,0,0,0.2)',
        borderColor: mm.getColor(7),
        borderDash: [2,3],
        borderWidth: 2,
        yAxisID: "y-axis-count",
        data:[]
      };
      mm.cfg.data.datasets.push(mm.map["guest_fail"]);

      mm.map["homes_tm"] = {
        label:"Home (sec)",
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: mm.getColor(0),//'rgba(255,0,0,1)',
        borderWidth: 2,
        yAxisID: "y-axis-dur",
        data:[]
      };
      mm.cfg.data.datasets.push(mm.map["homes_tm"]);
      
      mm.map["rooms_tm"] = {
        label:"Room (sec)",
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: mm.getColor(1),//'rgba(128,128,0,1)',
        borderWidth: 2,
        yAxisID: "y-axis-dur",
        data:[]
      };
      mm.cfg.data.datasets.push(mm.map["rooms_tm"]);
      
      mm.map["part_tm"] = {
        label:"Stream (sec)",
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: mm.getColor(2),
        borderWidth: 2,
        yAxisID: "y-axis-dur",
        data:[]
      };
      mm.cfg.data.datasets.push(mm.map["part_tm"]);

      mm.myChart1 = new Chart(ctx, mm.cfg);
      // end of chart creation
    } else {
      mm.cfg.data.labels.splice(0,mm.cfg.data.labels.length);
      mm.cfg.data.datasets.forEach(function(ds) {
        ds.data.splice(0,ds.data.length);
      });
    }

    mm.getHoursList().forEach(function(for_hr) {
      let stat = mm.all_stats[for_hr];
      mm.cfg.data.labels.push(new Date(for_hr * 1000));

      Object.keys(mm.map).forEach(function(name) {
        if (!stat || !stat[name]) {
          /* All zeros seems to throw off graph */
          mm.map[name].data.push(0.01);
        } else {
          //console.log("data",name,Math.trunc(stat[name]));
          mm.map[name].data.push(Math.trunc(stat[name]));
        }
      });
    });

    mm.myChart1.update();
  }

  createSessBar(sess) {
    let mm = this;
    let ctx = document.getElementById("mySess1").getContext('2d');
    //console.log(sess);
    if (mm.mySess1) {
      mm.mySess1.destroy();
    }
    
    let cfg = {
      type: 'horizontalBar',
      data: {
        labels: [],
        datasets: [],
      },
      options: {
        indexAxis: 'y',
        plugins: {
          title: {
            display: true,
            text: 'Chart.js Bar Chart - Stacked'
          },
        },
        //responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
          }],
          yAxes: [{
            stacked: true,
          }]
        }
      }
    };

    /*
    cfg.data.labels = ["A","B","C"];
    cfg.data.datasets = [{label:"X", data:[1,1,1], backgroundColor:"red"},
                         {label:"Y", data:[2,2,2], backgroundColor:"green"},
                         {label:"Z", data:[3,4,5], backgroundColor:"blue"}];
    */
    cfg.data.labels = ["A"];
    let base_tm;
    for (let i=0; i<sess.events.length; i++) {
      let ev = sess.events[i];
      let nxt_ev = sess.events[i+1];
      let name = ev.a;
      let color = "gray";
      let delta;

      if (!nxt_ev) {
        delta = 10;
      } else {
        delta = (nxt_ev.tm - ev.tm)/1000;
      }


      console.log("data",name,delta,color);
      cfg.data.datasets.push({
        label: name,
        data:[Math.log(delta)],
        backgroundColor: color,
      });
    }
    
    mm.mySess1 = new Chart(ctx, cfg);
  }

  };
